<template>
    <div :class="['totem-tree-select', size]">
        <Treeselect
            :options="options"
            :placeholder="placeholder"
            v-model="localSelectedCategories"
            :multiple="true"
            :flatten-search-results="true"
            valueConsistsOf="ALL_WITH_INDETERMINATE"
            v-on:select="selectOption"
            v-on:deselect="deselectOption"
            v-on:input="onInputChange"
            search-nested
        >
            <div slot="value-label" slot-scope="{ node }">{{ node.label }}</div>
        </Treeselect>
    </div>
</template>

<script>
    import Treeselect from '@riophae/vue-treeselect'
    import '@riophae/vue-treeselect/dist/vue-treeselect.css'

    export default {
        name: 'totem-tree-select',
        components: {
            Treeselect
        },
        props: {
            options: {
                type: Array,
                default: () => []
            },
            placeholder: String,
            value: [ String, Object ],
            size: {
                type: String,
                validator: (prop) => [ 'small', 'large' ].includes(prop)
            },
            icon: String,
            selectedOptions: Array
        },
        data () {
            return {
                content: this.value,
                localSelectedCategories: null
            }
        },
        watch: {
            selectedOptions () {
                this.localSelectedCategories = this.selectedOptions.map(category => category.value)
            }
        },
        methods: {
            onInputChange (picked) { // basicly for clearing select from plugin...
                if (picked.length === 0) {
                    this.$emit('deselectAll')
                }
            },
            deselectOption (node) {
                this.$emit('deselectOption', node)
            },
            selectOption (node) {
                this.$emit('input', node)
            },
            clear () {
                this.content = null
                this.$emit('input', this.content)
            },
            clearWithoutEmit () {
                this.content = null
            },
        }
    }
</script>

<style lang="scss">
.totem-tree-select {
   @include tree-select
}
</style>
